import { render, staticRenderFns } from "./AboutAuthor.vue?vue&type=template&id=67bd5b9d"
import script from "./AboutAuthor.vue?vue&type=script&lang=js"
export * from "./AboutAuthor.vue?vue&type=script&lang=js"
import style0 from "./AboutAuthor.vue?vue&type=style&index=0&id=67bd5b9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports